import { ButtonContainer } from "./Styled";

const ButtonsField = ({
	id,
	readOnly,
	handleClick,
	options,
	isSections,
	activeIconUrl,
	inactiveIconUrl,
}) => {

	if (activeIconUrl && inactiveIconUrl) {
		return (
			<a onClick={(e) => handleClick(e, "button", id)}>
				<img
					src={readOnly ? inactiveIconUrl : activeIconUrl}
					alt="toggle-icon"
					height="40px"
				/>
			</a>
		);
	}

	return (
		<div className="flex flex-row">
			{options?.map((option) =>
				option.iconUrl ? (
					<img
						key={option.label}
						src={option.iconUrl}
						alt="vessel-marker"
						className="w-[38px] h-[38px] cursor-pointer mr-2 mt-0 xl:mt-[22px]"
						onClick={(e) => handleClick(e, "button", id, option.label)}
					/>
				) : (
					<ButtonContainer
						key={id}
						id={id}
						variant="contained"
						color="primary"
						disabled={readOnly}
						onClick={(e) => handleClick(e, "button", id, option.label)}
						style={{
							float: isSections && "right",
							marginLeft: isSections ? "10px" : '5px',
							marginTop:'10px'
						}}
					>
						{option.label}
					</ButtonContainer>
				)
			)}
		</div>
	);
};

export default ButtonsField;
